/**
 * The `SCHEDULE_EDITOR_LAUNCHER` implementation the schedule field provides to its card.
 *
 * A service rather than a direct call so the card can inject the token, know nothing about
 * `WorkBuddyDialogService`, and be tested against a stub launcher.
 */

import { Injectable, Provider, inject } from '@angular/core';
import { ScheduleRule } from '@jms/model/scheduling';
import { WorkBuddyDialogService } from '@workbuddy/ui/v2/blocks/dialog';
import { SCHEDULE_EDITOR_LAUNCHER, ScheduleEditorDates, ScheduleEditorLauncher, ScheduleEditorResult } from './schedule.editor.launcher.contract';
import { SCHEDULE_EDITOR_CONTEXT } from './schedule.editor.context';
import { openScheduleEditor } from './schedule.editor.open';

@Injectable()
export class ScheduleEditorLauncherService implements ScheduleEditorLauncher {

  private readonly dialogs = inject(WorkBuddyDialogService);
  private readonly context = inject(SCHEDULE_EDITOR_CONTEXT);

  public open(model: ScheduleRule | undefined, options: { readonly?: boolean; dates?: ScheduleEditorDates }): Promise<ScheduleEditorResult | undefined> {

    return openScheduleEditor(this.dialogs, { context: this.context(), model, readonly: options.readonly, dates: options.dates });
  }
}

/** Wires the launcher wherever the schedule card is mounted. Needs SCHEDULE_EDITOR_CONTEXT alongside. */
export const scheduleEditorLauncherProviders: Provider[] = [
  ScheduleEditorLauncherService,
  { provide: SCHEDULE_EDITOR_LAUNCHER, useExisting: ScheduleEditorLauncherService },
];
